module.exports = __webpack_public_path__ + "img/edge_heng_logo.94532040.png";